import { Box, ScrollView, RenderHtml } from '@bonanza-social/moonlight';
import { Page, SplashScreen } from '@bonanza-social/navigation';
import { useCallback, useEffect, useState } from 'react';
import { TermsAndConditionsService } from '@bonanza-social/toolkit/services';
import { logError } from '@bonanza-social/toolkit/logging';
import TermsAndConditions from './Terms.types';

function TermsPage() {
  const [termsAndConditionsContent, setTermsAndConditionsContent] =
    useState<TermsAndConditions | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchTermsAndConditionsContent = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await TermsAndConditionsService.getTermsAndConditions();
      setTermsAndConditionsContent(data);
    } catch (error) {
      logError('Error fetching terms and conditions', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTermsAndConditionsContent();
  }, [fetchTermsAndConditionsContent]);

  if (isLoading || !termsAndConditionsContent) {
    return <SplashScreen />;
  }

  return (
    <Page
      titleKey="Bonanza social - Terms and Conditions | User Agreement for Fair Play"
      descriptionKey="If you are using or intending to play on Bonanza social, You do so in accordance with these Terms of Service."
    >
      <ScrollView showsHorizontalScrollIndicator={false}>
        <Box centerContent>
          <Box
            width={{
              desktop: '50%',
              tablet: '70%',
              mobile: '100%',
            }}
            alignItems="center"
            paddingHorizontal="space-400"
          >
            {/* <Text
              variant="body-m"
              color="darkSurfacePrimary"
              textAlign="left"
              width={'100%'}
            >
              {`Latest Revision Date: ${formatDate(
                termsAndConditionsContent.publishDate,
                'DD/MM/YYYY HH:mm',
              )}`}
            </Text>
            <br></br> */}

            <RenderHtml
              html={termsAndConditionsContent.content}
              variant="body-m"
            />
          </Box>
        </Box>
      </ScrollView>
    </Page>
  );
}

export default TermsPage;
